{
	"type": "fill",
	"minzoom": 8,
	"layout": {},
	"paint": {
		"fill-color": [
			"step",
			["get", "irsad_decile"],
			"#000",
			1.01,
			"#520d8e",
			2.01,
			"#881b9e",
			3.01,
			"#bc2e9a",
			4.01,
			"#f04188",
			5.01,
			"#ff5c6a",
			6.01,
			"#ff8345",
			7.01,
			"#ffb71b",
			8.01,
			"#ffff64",
			9.01,
			"#ffffeb"
		],
		"fill-outline-color": "#666",
		"fill-antialias": true
	}
}
